import { create } from 'zustand'
import axios from 'axios'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

import { CRUDBaseStore } from './Base/CRUD'

interface ShippingRequestStore extends CRUDBaseStore {
  selectedId: any
  setSelectedId: (selectedId: any) => void
  getOne: (id: number) => Promise<{ success: boolean; data: any }>
}

export const API_SLUG = 'shippingRequest'

export const INITIAL_STATE = {
  shippingItems: [] as any[],
  requestMessage: '' as string,
}

export const useShippingRequestStore = create<ShippingRequestStore>(set => ({
  data: [],
  selected: INITIAL_STATE,
  selectedId: undefined,
  loading: false,
  error: undefined,
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  setError: (error: any) => {
    set({ error })
  },
  setSelected: (selected: any) => {
    set({ selected })
  },
  setSelectedId: (selectedId: any) => {
    set({ selectedId })
  },
  getAll: async (filter: any) => {
    set({ loading: true })
    const finaleFilter = cleanParamsFilter(filter)

    return axios
      .get(`/${API_SLUG}`, { params: finaleFilter })
      .then(res => {
        set({ data: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getOne: async id => {
    set({ loading: true })

    return axios
      .get(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ selected: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  create: async (data: any) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        if (key === 'shippingItems') {
          data[key].forEach((piles: any, idx: number) => {
            // formData.append(`piles[${idx}][pileTitle]`, piles.itemTitle)
            formData.append(`piles[${idx}][groupLetter]`, piles.groupLetter)
            formData.append(`piles[${idx}][pileQuantity]`, piles.pileQuantity)
            formData.append(`piles[${idx}][pileLength]`, piles.actualQuantity)
          })
        } else {
          formData.append(key, data[key])
        }
      }
    })
    return axios
      .post(`/${API_SLUG}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  edit: async (id, data) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        if (key === 'shippingItems') {
          console.log('data[key]',data[key])
          data[key].forEach((piles: any, idx: number) => {
            if (piles.isEdit) {
              if (piles.id) {
                formData.append(`piles[${idx}][id]`, piles.id)
              }
              if (piles.isDelete) {
                formData.append(`piles[${idx}][isDelete]`, piles.isDelete)
              }

              // formData.append(`piles[${idx}][pileQuantity]`, piles.pileQuantity)
              // formData.append(`piles[${idx}][pileTitle]`, piles.itemTitle)
              formData.append(`piles[${idx}][pileCode]`, piles.itemCode)
              formData.append(`piles[${idx}][pileLength]`, piles.actualQuantity)
            }
          })
        } else {
          formData.append(key, data[key])
        }
      }
    })

    return axios
      .patch(`/${API_SLUG}/${id}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  delete: async id => {
    set({ loading: true })
    return axios
      .delete(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  clearState: () => {
    set({
      data: [],
      loading: false,
      error: undefined,
      selected: INITIAL_STATE,
      selectedId: undefined,
    })
  },
}))
